<template>
  <Drawer
    class="ls_drawer_main"
    :title="title"
    width="700"
    v-model="showDrawer"
  >
    <shiftDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></shiftDetail>

  </Drawer>
</template>

<script>
  import { BaseItemData } from "../../base/base_item.js";

  // import customerForm from "@/apps/shift/customerForm.vue";
  import shiftDetail from "@/apps/shift/shiftDetail.vue";

  let _app = BaseItemData();
  _app.components = {
    shiftDetail
  };
  _app.data = function() {
    return {
      titles: {
        detail: "Смена",
        // edit: "Редактирование смены",
        // create: "Создание смены"
      },
      itemAction: "detail",
      itemId: "",
      showDrawer: false
    };
  };
  export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/shift/shiftItem.vue